import Icons from "../../assets/icon/index";
import { Controller } from "react-hook-form";
import { fontSizes } from "../../constants/constants";
import { IoClose } from "react-icons/io5";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./custom-datepicker.css";
import Cropper from "react-easy-crop"; // Cropper library
import Modal from "react-modal"; // Modal for cropper
import {
  Text,
  Newlogo,
  DefaultValueCountry,
  Authslide,
  Button,
  FormInput,
} from "../../components";
import Functions from "./index.function";

Modal.setAppElement("#root"); // Accessibility

const Register = () => {
  const {
    TextWeight,
    handleSubmit,
    onSubmit,
    control,
    errors,
    register,
    setValue,
    setCountryCode,
    getValues,
    navigate,
    loadingToapi,
    usernameType,
    isVoteToWinRequired,
    voteToWinImage,
    isVoteToWinImageSelected,
    apiMessage,
    setApiMessage,
    isDragging,
    handleDrop,
    handleDragOver,
    setIsDragging,
    handleCheckboxChange,
    isDropdownLoading,
    dropdowns,
    isError,
    error,
    // Cropper related
    cropperOpen,
    imageToCrop,
    crop,
    zoom,
    setCrop,
    setZoom,
    onCropComplete,
    handleImageSelect,
    handleCropSave,
    handleCropCancel, 
    setCca2,
  } = Functions();
  return (
    <div className="bg-primary">
      <div className="lg:py-10 max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <div className="my-5 sm:my-7 lg:my-10 flex justify-center items-center">
          <Newlogo />
        </div>
      </div>
      <Authslide />
      <div className="max-w-7xl lg:px-5 xl:px-10  sm:px-5 xs:px-3 m-auto">
        <div className="lg:py-8">
          <Text
            text={"Create Account"}
            size={fontSizes.h30}
            weight={TextWeight.Unbounded_bold}
            color="text-secondary"
            isCenter={true}
            isTruncate={false}
          />
          <Text
            text={"Welcome! Please enter your details."}
            size={fontSizes.h16}
            weight={TextWeight.Montserrat_medium}
            color="text-secondary"
            isCenter={true}
            isTruncate={false}
            className={"lg:pt-5"}
          />
        </div>
        <form
          className="flex justify-center items-center flex-col"
          onSubmit={handleSubmit(onSubmit, (errors) => {
            Object.keys(errors).forEach(key => {
            });
          })}
        >
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[85%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] sm:w-1/2">
              <FormInput
                userData={""}
                control={control}
                errors={errors}
                label="First Name"
                type="text"
                name="firstName"
                placeholder="Enter First Name"
                maxLength={30}
                isMandatory={true}
                isRequired={true}
                pattern={{
                  value: /^[A-Za-z\s]+$/,
                  message: "First Name can only contain letters",
                }}
              />
            </div>
            <div className="relative mt-[18px] sm:w-1/2">
              <FormInput
                userData={""}
                control={control}
                errors={errors}
                label="Last Name"
                type="text"
                placeholder="Enter Last Name"
                name="lastName"
                maxLength={30}
                isMandatory={true}
                isRequired={true}
                pattern={{
                  value: /^[A-Za-z\s]+$/,
                  message: "Last Name  can only contain letters",
                }}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[85%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            {/* Date of Birth Field */}
            
              <Controller
                control={control}
                name="dob"
                rules={{
                  required: "Date of Birth is required",
                }}
                render={({ field }) => (
                  <div className="relative mt-[18px] sm:w-1/2">
                    <p className=" xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary truncate   undefined ">Date of Birth <span className="text-errorRed">*</span></p>
                    <DatePicker
                      placeholderText="Select your date of birth"
                      selected={field.value ? new Date(field.value) : null}
                      onChange={(date) => field.onChange(date)}
                      maxDate={new Date()} // Prevent future dates
                      dateFormat="dd-MM-yyyy" // Format for frontend display (DMY)
                      className="xs:pl-6 xs:!mb-[2px] sm:mb-1 sm:pl-6 lg:pl-8 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-4 rounded-full focus:outline-none text-[#808080] focus:bg-primary transition duration-300 delay-100 focus:ring-2 focus:ring-goldMetallic"
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                    />
                    {errors.dob && <span className="text-orangeCrayola xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">{errors.dob.message}</span>}
                  </div>
                )}
              />

            {/* Gender Field */}
            <div className="relative mt-[18px] sm:w-1/2">
              <p className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary truncate text-[16px] font-family: Onest-Regular">
                Select Gender
                <span className="text-errorRed">*</span>
              </p>
              <select
                name="gender_id"
                {...register("gender_id", { required: "Gender is required" })}
                className="appearance-none xs:pl-6 xs:!mb-[2px] sm:mb-1 sm:pl-6 lg:pl-8 bg-[#171717] xs:text-sm sm:text-base font-onestRegular w-full xs:py-3 sm:py-4 rounded-full focus:outline-none text-[#808080] focus:bg-primary transition duration-300 delay-100 focus:ring-2 focus:ring-goldMetallic pr-12"
                disabled={isDropdownLoading}
              >
                <option value="">Select Gender</option>
                {dropdowns?.gender?.length > 0 ? (
                  dropdowns.gender.map((g) => (
                    <option key={g.id} value={g.gender_id}>
                      {g.gender}
                    </option>
                  ))
                ) : (
                  <option disabled>Loading...</option>
                )}
              </select>

              {isError && (
                <span className="text-orangeCrayola xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">
                  Error loading gender list: {error?.message}
                </span>
              )}


              {/* Custom dropdown arrow */}
              <svg
                className="pointer-events-none absolute right-6 top-[60px] -translate-y-1/2"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <polyline
                  points="6 9 12 15 18 9"
                  stroke="#808080"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              {errors.gender && (
                <span className="text-orangeCrayola    xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">{errors.gender.message}</span>
              )}
            </div>
          </div>

          {/* Username Radio Buttons (Email/Phone) */}
          {/* <div className="relative mt-[18px] sm:w-[85%] xs:w-full lg:w-[70%]">
            <p className="xs:mb-1.5 xs:pl-6 sm:mb-2 sm:pl-6 lg:mb-2 lg:pl-8 flex justify-start items-center text-secondary truncate text-[16px] font-family: Onest-Regular">
              Username
              <span className="text-errorRed">*</span>
            </p>
            <div
              className={
                "flex xs:flex"
              }
            >
              <div className="relative">
                <label className="custom-radio cursor-pointer w-100 flex justify-center items-center md:text-[17px] text-[18px] 3xl:text-[20px] font-raleway">
                  <input
                    type="radio"
                    name="usernameType"
                    value="email"
                    className="hidden peer"
                    {...register("usernameType", { required: "Please select a username type" })} 
                  />
                  <span class="w-8 h-8 inline-block bg-[#212121] rounded-full relative peer-checked:bg-[#212121] peer-checked:after:absolute peer-checked:after:top-1/2 peer-checked:after:left-1/2 peer-checked:after:w-4 peer-checked:after:h-4 peer-checked:after:-translate-x-1/2 peer-checked:after:-translate-y-1/2 peer-checked:after:rounded-full peer-checked:after:bg-[#808080]"></span>
                  <p className="ml-3 xs:text-[16px] text-[16px] text-[#fff] ">Email</p>
                </label>
                </div>
              <div className="relative ">
                <label className="flex items-center custom-radio pl-10">
                  <input
                    type="radio"
                    name="usernameType"
                    value="phone"
                    className="hidden peer"
                    {...register("usernameType", { required: "Please select a username type" })} 
                  />
                  <span class="w-8 h-8 inline-block bg-[#212121] rounded-full relative peer-checked:bg-[#212121] peer-checked:after:absolute peer-checked:after:top-1/2 peer-checked:after:left-1/2 peer-checked:after:w-4 peer-checked:after:h-4 peer-checked:after:-translate-x-1/2 peer-checked:after:-translate-y-1/2 peer-checked:after:rounded-full peer-checked:after:bg-[#808080]"></span>
                  <p className="ml-3 xs:text-[16px] text-[16px] text-[#fff] ">Phone</p>
                </label>
              </div>
            </div>
            {errors.usernameType && (
              <span className="text-orangeCrayola    xs:pl-6 sm:pl-6 lg:pl-8 text-[14px]">{errors.usernameType.message}</span>
            )}
          </div> */}
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[85%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-[18px] sm:w-1/2">
              <FormInput
                label="Email Address"
                control={control}
                name="email"
                type="email"
                placeholder="Enter Email Address"
                rules={{
                  required:
                    usernameType === "email" ? "Email is required" : false, // ✅ conditional
                  pattern: {
                    value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                    message: "Please enter a valid email address",
                  },
                }}
                errors={errors}
              />



            </div>
            <div className="relative mt-[18px] sm:w-1/2">
              <DefaultValueCountry
                label="Phone Number"
                type="text"
                name="mobile_num"
                placeholder="Enter Mobile Number"
                defaultValue={""}
                countryCode={""}
                cca2={""}
                control={control}
                register={register}
                isMandatory={true}
                onChange={(value) => setValue("mobile_num", value)}
                errors={errors}
                setCountryCode={setCountryCode}
                setCca2={setCca2}
              />

            </div>
          </div>
          
          {/*  <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[85%] lg:w-[70%] sm:gap-2 lg:gap-4 mt-[18px]"
            }
          >
            <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
              <PrefilledDropDown
                options={dropdowns?.country || []}
                control={control}
                name="country_id"
                label="Country"
                rightIcon={Icons.arrowIcon}
                isMandatory={true}
                valueoption="country_id"
                valueName="country"
                errors={errors}
                isLoading={isLoading}
              />
            </div>
            <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
              <PrefilledDropDown
                control={control}
                errors={errors}
                rightIcon={Icons.arrowIcon}
                label={"Province / State"}
                options={states}
                valueName="state"
                isMandatory={true}
                valueoption="state_id"
                name={"state_id"}
                isLoading={isLoadingStates}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[85%] lg:w-[70%] sm:gap-2 lg:gap-4 mt-[18px]"
            }
          >
            <div className=" w-full">
              <PrefilledDropDown
                control={control}
                errors={errors}
                rightIcon={Icons.arrowIcon}
                label={"City"}
                options={cities}
                valueName="city"
                isMandatory={true}
                valueoption="city_id"
                name={"city_id"}
                isLoading={citiesisLoading}
              />
            </div>
          </div>*/}
          {/* 
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[85%] lg:w-[70%] sm:gap-2 lg:gap-4 mt-[18px]"
            }
          >
            <div className="w-full">
              <FormInput
                label="Referral Code"
                control={control}
                userData={""}
                type="text"
                name="referral_code"
                isRequired={true}
                errors={errors}
              />
            </div>
          </div>
           */}
          {/* <div className="flex justify-start items-center mt-[18px] sm:w-[85%] xs:w-full lg:w-[70%] lg:pt-3 lg:pb-4">
                        <input
                            type="checkbox"
                            id="keepPrivate"
                            name="keepPrivate"
                            className="custom-checkbox"
                            checked={keepPrivate}
                            onChange={handleKeepPrivateChange}
                        />
                        <label htmlFor="keepPrivate" className="text-[#808080] ml-2 cursor-pointer">
                            Keep It Private
                        </label>
                    </div> */}
          <div
            className={
              "flex xs:flex-col mt-[18px] xs:w-full sm:w-[85%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="relative mt-4 sm:w-1/2">
              <FormInput
                control={control}
                userData={""}
                label="Password"
                type="password"
                name="password"
                placeholder="Password"
                isPassword={true}
                isMandatory={true}
                isRequired={true}
                iconPasswordVisible={Icons.showPasswordIcon}
                iconPasswordHidden={Icons.hidePasswordIcon}
                iconStyle={
                  "xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-6 w-7 3xl:w-8 3xl:h-7"
                }
                // maxLength={30}
                pattern={{
                  value: /^(?=.*[A-Z])(?=.*\d).{8,}$/,
                  message:
                    "Password must be at least 8 characters long, contain at least 1 uppercase letter and 1 number",
                }}
                errors={errors}
              />
            </div>
          </div>
          <div
            className={
              "flex xs:flex-col xs:w-full sm:w-[85%] lg:w-[70%] pl-6 sm:pl-6 lg:pl-8"
            }
          >
            <p style={{
              fontSize: '14px',
              color: '#989898',
              fontStyle: 'italic',
              marginTop: '10px',
              textAlign: 'left',
              fontWeight: 400
            }}>
              Password must be at least 8 characters long, contain at least 1 uppercase letter and 1 number
            </p>
            
          </div>


          <div className={"flex xs:flex-col xs:w-full sm:w-[85%] lg:w-[70%] sm:gap-2 lg:gap-4"}>
            <div className="relative mt-[18px] sm:w-1/2">
              <FormInput
                userData={""}
                control={control}
                errors={errors}
                label="Referral Code"
                type="text"
                name="referral_code"
                placeholder="Please enter referral code (Optional)"
                maxLength={30}
                isMandatory={false}
                isRequired={false}
                // pattern={{
                //   value: /^[A-Za-z\s]+$/,
                //   message: "First Name can only contain letters",
                // }}
              />
            </div>
            <div className="relative mt-[18px] sm:w-1/2">
              <FormInput
                userData={""}
                control={control}
                errors={errors}
                label="Event Code"
                type="text"
                placeholder="Please enter event code (Optional)"
                name="event_code"
                maxLength={30}
                isMandatory={false}
                isRequired={false}
                // pattern={{
                //   value: /^[A-Za-z\s]+$/,
                //   message: "Last Name  can only contain letters",
                // }}
              />
            </div>
          </div>
          

          <div
            className={
              "flex flex-col xs:w-full sm:w-[85%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="flex justify-start items-center mt-5">
              <label className="custom-radio cursor-pointer w-9 flex justify-center items-center md:text-[17px] text-[18px] 3xl:text-[20px] font-raleway">
                <input
                  type="radio"
                  {...register("termsAndConditions", {
                    required: "You must agree to the terms and conditions",
                  })}
                  className="hidden peer"
                />
                <span className="w-8 h-8 inline-block bg-[#212121] rounded-sm peer-checked:bg-[#808080] peer-checked:after:content-['✓'] peer-checked:after:block peer-checked:after:text-secondary peer-checked:after:text-center peer-checked:after:leading-7"></span>
              </label>
              <p className="ml-3 xs:text-[16px] sm:text-[16px] md:text-[17px] text-[18px] 3xl:text-[20px] text-[#808080] ">
                I agree to the{" "}
                <span
                  className="underline text-[#808080] hover:text-goldMetallic cursor-pointer transition duration-300 ease-in-out"
                  onClick={() => navigate("/terms-and-conditions")}
                >
                  Terms & Conditions
                </span>{" "}
                of the Global Entertainment Movement
              </p>
            </div>
            <div className="flex justify-start items-center xs:pl-6 sm:pl-6 lg:pl-8 xs:pt-[2px]">
              {errors.termsAndConditions && (
                <span className="text-orangeCrayola font-onestRegular xs:text-xs sm:text-sm">
                  {errors.termsAndConditions.message}
                </span>
              )}
            </div>
          </div>

          <div
            className={
              "flex flex-col xs:w-full sm:w-[85%] lg:w-[70%] sm:gap-2 lg:gap-4"
            }
          >
            <div className="flex justify-start items-center mt-5">
              <label className="custom-radio cursor-pointer w-9 flex justify-center items-center md:text-[17px] text-[18px] 3xl:text-[20px] font-raleway">
                <input
                  type="checkbox"
                  name="agreeOnVoteToWin"
                  className="hidden peer"
                  {...register("agreeOnVoteToWin")}
                  onChange={(e) => handleCheckboxChange(e)}
                />
                <span className="w-8 h-8 inline-block bg-[#212121] rounded-sm peer-checked:bg-[#808080] peer-checked:after:content-['✓'] peer-checked:after:block peer-checked:after:text-secondary peer-checked:after:text-center peer-checked:after:leading-7"></span>
              </label>
              <p className="ml-3 xs:text-[16px] sm:text-[16px] md:text-[17px] text-[18px] 3xl:text-[20px] text-[#808080] ">
                I agree to be part of the Vote to Win Program for exciting prizes through
                a lucky draw
              </p>
            </div>
          </div>

          <div className="xs:w-full sm:w-[90%] lg:w-[70%]">
            {isVoteToWinRequired && (
              <div className="flex sm:gap-2 lg:gap-4">
                <div className="xs:py-2 sm:py-3 lg:py-4 w-full">
                  <div className="xs:mb-2 xs:pl-8 sm:mb-2 sm:pl-7 lg:mb-5 lg:pl-8">
                    <p className="xs:text-lg lg:text-lg font-josefinSansRegular text-secondary">
                      Vote To Win Image
                    </p>
                  </div>
                  <div className="text-[#808080] text-sm pl-8 pt-2">
                    <p className="xs:text-lg lg:text-lg">Aspect ratio: <strong>530:715 (≈ 3:4)</strong></p>
                    <p className="xs:text-lg lg:text-lg">Maximum file size: <strong>2MB</strong></p>
                  </div>

                  <div
                    className={`bg-[#171717] xs:px-4 rounded-3xl flex flex-col ${
                      voteToWinImage instanceof File
                        ? "justify-center items-start xs:py-4 sm:py-5 sm:px-4 lg:px-10 lg:py-5"
                        : "justify-center items-center xs:py-5 sm:py-6 lg:py-10"
                    } ${
                      isDragging
                        ? "border-2 border-dashed border-orangeCrayola"
                        : "border-dashed border-transparent"
                    }`}
                    onDrop={handleDrop}
                    onDragOver={handleDragOver}
                    onDragEnter={() => setIsDragging(true)}
                    onDragLeave={() => setIsDragging(false)}
                  >
                    {voteToWinImage instanceof File ? (
                      <div className="flex w-full justify-between items-center">
                        <div className="flex items-center xs:gap-1 sm:gap-2 lg:gap-2">
                          <div>
                            <img
                              className="sm:w-10 xs:w-8 lg:w-11"
                              src={URL.createObjectURL(voteToWinImage)}
                              alt={voteToWinImage.name}
                            />
                          </div>
                          <div>
                            <p className="text-[#808080] font-onestRegular xs:text-sm sm:text-sm lg:text-lg">
                              {voteToWinImage.name}
                            </p>
                            <p className="text-[#808080] font-onestLight xs:text-sm sm:text-sm lg:text-lg">
                              {voteToWinImage.size < 1024 * 1024
                                ? `${(voteToWinImage.size / 1024).toFixed(2)} KB`
                                : `${(voteToWinImage.size / (1024 * 1024)).toFixed(2)} MB`}
                            </p>
                          </div>
                        </div>
                        <div
                          className="group flex justify-center items-center xs:w-5 xs:h-5 sm:w-7 sm:h-7 lg:w-8 lg:h-8 rounded-full bg-[#393939] cursor-pointer transform transition-transform duration-300 hover:scale-110 hover:bg-red-700"
                          onClick={() => setValue("voteToWinImage", null)}
                        >
                          <IoClose className="text-secondary xs:text-lg sm:text-xl lg:text-2xl transform transition-transform duration-300 group-hover:rotate-180" />
                        </div>
                      </div>
                    ) : (
                      <>
                        <img src={Icons.uploadIcon} alt="upload" />
                        <div className="xs:pt-1 lg:pt-3 text-center">
                          <label
                            htmlFor="voteToWinImage_Upload"
                            className="font-onestRegular xs:text-sm text-[#808080] cursor-pointer"
                          >
                            Drag & Drop or Click to Upload Image
                          </label>
                          <input
                            id="voteToWinImage_Upload"
                            type="file"
                            accept="image/*"
                            name="voteToWinImage"
                            onChange={handleImageSelect}
                            className="hidden"
                          />

                        </div>
                      </>
                    )}
                  </div>

                  <div className="flex justify-start items-center pt-1.5">
                    {!voteToWinImage && (
                      <span className="text-orangeCrayola font-onestRegular xs:text-xs sm:text-sm">
                        Vote To Win Image is required
                      </span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          <Button
            text="Register"
            type={"submit"}
            bgColor="gradient-container_btn"
            color="text-secondary"
            className="xs:w-56 xs:h-10 sm:w-60 sm:h-12 lg:w-64 lg:h-12 my-10 lg:my-8"
            textSize={fontSizes.h16}
            weight={TextWeight.Onest_semiBold}
            loading={loadingToapi}
            onClick={() => {
            }}
            isDisabled={
              loadingToapi || (isVoteToWinRequired && !isVoteToWinImageSelected)
            }
          />
        </form>
        <Text
          text={
            <>
              <span>Already have an account?&nbsp;</span>
              <Text
                text="Login"
                onClick={() => navigate("/login")}
                className="text-secondary cursor-pointer hover:text-strong_Cyan hover:underline"
              />
            </>
          }
          size={fontSizes.h14}
          weight={TextWeight.Onest_regular}
          color="text-secondary"
          className={"flex justify-center items-center pb-5"}
        />
        {/* <Text
          text="Sign Up with google"
          className="flex justify-center w-fit mx-auto items-center xs:pt-2 sm:pt-2 sm:pb-4 lg:pt-3 gap-2 xs:pb-5 lg:pb-5 text-secondary cursor-pointer hover:underline"
          icon={Icons.googleIcon}
          size={fontSizes.h14}
          weight={TextWeight.Onest_medium}
        /> */}
      </div>

      {/* API Response Message Modal */}
      {apiMessage && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-[#171717] rounded-3xl p-8 max-w-md mx-4 border-2 border-goldMetallic">
            <div className="flex flex-col items-center">
              <div className="w-16 h-16 rounded-full bg-goldMetallic flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h3 className="text-secondary font-unboundedBold text-xl mb-3 text-center">
                Registration Submitted
              </h3>
              <p className="text-secondary font-montserratMedium text-center mb-6">
                {apiMessage}
              </p>
              <button
                onClick={() => {
                  setApiMessage(null);
                  navigate("/");
                }}
                className="gradient-container_btn text-secondary font-onestSemiBold px-8 py-3 rounded-full hover:scale-105 transition-transform"
              >
                Go to Home
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Vote To Win Image Cropper Modal */}
      <Modal
        isOpen={cropperOpen}
        onRequestClose={handleCropCancel}
        contentLabel="Image Cropper"
        className="w-full max-w-3xl mx-auto bg-[#1A1A1A] rounded-lg shadow-xl overflow-hidden"
        overlayClassName="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50 p-4"
      >
        <div className="relative">
          {/* Header */}
          <div className="bg-[#212121] px-6 py-4 border-b border-gray-700 flex justify-between items-center">
            <h2 className="text-white text-xl font-semibold">
              Crop Vote To Win Image (650×866 px)
            </h2>
            <button
              onClick={handleCropCancel}
              className="text-gray-400 hover:text-white transition-colors"
            >
              <IoClose size={24} />
            </button>
          </div>

          {/* Cropper */}
          <div className="relative w-full h-96 bg-black">
            <Cropper
              image={imageToCrop}
              crop={crop}
              zoom={zoom}
              aspect={650 / 866} // 650x866 aspect ratio
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onCropComplete={onCropComplete}
            />
          </div>

          {/* Controls */}
          <div className="bg-[#212121] px-6 py-4 space-y-4">
            <div>
              <label className="text-white text-sm mb-2 block">Zoom</label>
              <input
                type="range"
                min={1}
                max={3}
                step={0.1}
                value={zoom}
                onChange={(e) => setZoom(e.target.value)}
                className="w-full accent-[#D4AF37]"
              />
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-4">
              <button
                onClick={handleCropCancel}
                className="px-6 py-2 bg-gray-600 text-white rounded-full hover:bg-gray-700 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleCropSave}
                className="px-6 py-2 bg-gradient-to-r from-[#D4AF37] to-[#F4D03F] text-black font-semibold rounded-full hover:scale-105 transition-transform"
              >
                Apply Crop
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};
export default Register;